import { Box, Button, Divider, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { GifColors } from "../../../../../theme";
import EditIcon from "@mui/icons-material/Edit";
import { useSelector } from "react-redux";
import { isCoordinatorSelector } from "../../../../../store/advisorSlice";
import VisibilityIcon from "@mui/icons-material/Visibility";

const useStyles = makeStyles((theme) => ({
  typography: {
    fontWeight: 500,
    fontSize: 15,
  },
  typography2: {
    fontWeight: 600,
    fontSize: 16,
  },
  typographyError: {
    marginTop: 10,
    marginBottom: 10,
    fontWeight: 500,
    fontSize: 18,
    color: "#660000",
  },
  editButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
  },
  viewButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
  },
  miniHeader: {
    marginBottom: 4,
    fontWeight: 500,
    fontSize: 18,
    color: GifColors.darkBlue,
  },
}));

export default function GradeBox(props) {
  const classes = useStyles();
  const {
    title,
    grade,
    rank,
    notAssgin,
    openGarde,
    notAssignToMe,
    panel,
    totalProposalNumber,
    viewOnly,
  } = props;
  const isCoordinator = useSelector(isCoordinatorSelector);

  return (
    <>
      <Typography className={classes.miniHeader}>{title}</Typography>
      <Box bgcolor={GifColors.lightBlue} marginLeft={1} marginRight={1}>
        <Divider />
        {notAssgin ? (
          <>
            <Typography className={classes.typographyError}>
              Proposal not yet assign to advisor
            </Typography>
          </>
        ) : (
          <>
            <Box padding={1}>
              <Typography className={classes.typography}>Grading</Typography>
              <Typography className={classes.typography2}>{grade}</Typography>
            </Box>
            <Box padding={1}>
              <Typography className={classes.typography}>Ranking</Typography>
              <Typography
                className={classes.typography2}
              >{`${rank}/${totalProposalNumber}`}</Typography>
            </Box>
          </>
        )}
        {viewOnly||(!panel && notAssignToMe) || (panel && !isCoordinator) ? (
          <Button
            fullWidth
            disableElevation
            variant="contained"
            className={classes.viewButton}
            startIcon={<VisibilityIcon />}
            disabled={notAssgin}
            onClick={() => openGarde(true)}
          >
            View
          </Button>
        ) : (
          <Button
            fullWidth
            disableElevation
            variant="contained"
            className={classes.editButton}
            startIcon={<EditIcon />}
            // disabled={(!panel&&(notAssgin || notAssignToMe)) || (panel && !isCoordinator)}
            onClick={() => openGarde(false)}
          >
            Edit
          </Button>
        )}
      </Box>
    </>
  );
}
